import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Card, DataListItem } from '@node-space/ui-components'

interface ContactCardProps {
  name: string
  showAvatar?: boolean
  title?: string
}

export const ContactCard = ({ name, showAvatar = true, title = '' }: ContactCardProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full>
      <DataListItem
        size="large"
        layout="vertical"
        id="contact-card"
        title={title ?? t('contacts.cryptoContact')}
        BodyAvatar={showAvatar && <Avatar size="small" type="entity" name={name ?? ''} />}
        body={name}
      />
    </Card>
  )
}
